document.addEventListener("DOMContentLoaded", function () {
  var popupEl = document.getElementById("popup-form");
  if (!popupEl) return;

  // Show popup after 10 seconds
  setTimeout(function () {
    popupEl.style.display = "flex";
  }, 10000);

  // Close popup
  document.querySelector(".close-btn").addEventListener("click", function () {
    popupEl.style.display = "none";
  });

  // Close on overlay click (outside the box)
  popupEl.addEventListener("click", function (e) {
    if (e.target === popupEl) {
      popupEl.style.display = "none";
    }
  });

  // Handle form submission and redirect
  var popupForm = document.getElementById("popup_contact_form");
  popupForm.addEventListener("submit", function (e) {
    e.preventDefault();

    var formData = new FormData(popupForm);

    fetch("/contact#contact_form", {
      method: "POST",
      body: formData,
    })
      .then(function (response) {
        if (response.ok) {
          window.location.href = "https://aestheticbk.com/pages/thank-you";
        } else {
          alert("There was a problem submitting your form. Please try again.");
        }
      })
      .catch(function (error) {
        console.error("Form submission error:", error);
        alert("There was an error. Please try again later.");
      });
  });
});